import Model, { Casts } from "./Model";
import type {
    SubscriptionPlan,
    SubscriptionSeason,
} from "@/types/Subscription";

export default class User extends Model<User>() {
    name?: string;
    profile_picture?: string;
    profilePicture?: string;
    points?: number;
    subscriptionTypeRecurring?: SubscriptionPlan | null;
    subscriptionSeasons?: SubscriptionSeason[];

    public static api_url = "/users";

    public casts: Casts = {
        profilePictureUrl: {
            get: (attributes) => {
                const path =
                    attributes.profilePicture ?? attributes.profile_picture;
                if (!path) {
                    return null;
                }
                if (path.startsWith("http://") || path.startsWith("https://")) {
                    return path;
                }
                const apiUrl = (import.meta.env.VUE_APP_API_URL || "").replace(
                    /\/$/,
                    "",
                );
                return `${apiUrl}${path.startsWith("/") ? path : `/${path}`}`;
            },
        },
    };

    get activeSubscriptionPlan(): SubscriptionPlan | null {
        if (this.subscriptionTypeRecurring) {
            return this.subscriptionTypeRecurring;
        }
        if (this.subscriptionSeasons && this.subscriptionSeasons.length > 0) {
            const planOrder: SubscriptionPlan[] = ["pro", "plus", "basis"];
            for (const plan of planOrder) {
                if (this.subscriptionSeasons.some((s) => s.plan === plan)) {
                    return plan;
                }
            }
        }
        return null;
    }
}
